import React from 'react';
import parse from 'html-react-parser';
import './AboutSection.scss';

export default function AboutSection({
  imgUrl,
  title,
  titleUp,
  subTitle,
}) {
  return (
    <div className="health-section hero-section">
      <div className="container">
        <div className="row align-items-center">

          {/* Image Section */}
          <div className="col-lg-6">
            <div className="image-box">
              <img src={imgUrl} alt="About" />
            </div>
          </div>

          {/* Content Section */}
          <div className="col-lg-6">
            <div className="content-box">
              <h5 className="subtitle">{titleUp}</h5>
              <h2 className="title">{parse(title)}</h2>
              <p className="desc">{parse(subTitle)}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}